// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bilpopHeader[data-v-bdc6254c]{background:linear-gradient(166deg,#400677 -6.27%,#6e2fbf)}.emojileHeader[data-v-bdc6254c]{background:linear-gradient(166deg,#00084d -6.27%,#2c4389 106.87%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
